// @flow
import SMConst from 'frontend_core/dist/constants/sm-const'
import { ownerName } from 'frontend_core/dist/helpers/format'
import ReservationModel from 'frontend_core/dist/model/Reservation'

import Path from 'routes/path'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import { containerIds } from 'redux/modules/ui'
import { getReservationCurrentStatusSectionProps } from 'components/organisms/ReservationCurrentStatusSection/presenter'
import { getReservationDetailSectionProps } from 'components/organisms/ReservationDetailSection/presenter'
import { getReservationHostSectionProps } from 'components/organisms/ReservationHostSection/presenter'

export function getReservationSidebarProps(
  reservationDetail: ReservationDetailState,
  uiState: {
    isShowContentsSp: boolean,
  },
  actions: { ...ReservationDetailActions, setUIState: Function },
  onClickLink: (url: string) => void,
) {
  const { detail: reservation } = reservationDetail
  const owner = reservation.owner || {}

  return {
    hrefBackToReservations: Path.reservations(),
    hrefTokushoho: Path.tokushoho(owner.username),
    isShowContentsSp: uiState.isShowContentsSp,
    onClickDetailTab: () =>
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        isShowContentsSp: false,
      }),
    onClickMessageTab: () =>
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        isShowContentsSp: true,
      }),
    reservationId: reservation.id,

    reservationCurrentStatusSectionProps: getReservationCurrentStatusSectionProps(
      reservation,
      onClickLink,
    ),
    reservationDetailSectionProps: getReservationDetailSectionProps(
      reservation,
      onClickLink,
    ),
    reservationHostSectionProps: getReservationHostSectionProps(owner),
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationSidebar/presenter.js